import React from "react";
import "./HistorySection.scss";
import Banner from "./Banner";
import StepFlow from "./StepFlow";

const HistorySection = () => {
  return (
    <>
      {/* <section className="history-section">
      <div className="container">
        <h2 className="section-title">Our Journey & Legacy</h2>
        <p className="intro">
          Bengaluru Law College has grown into a vibrant hub of excellence in
          legal education, discipline, and community service. Here’s a glimpse
          into our inspiring journey:
        </p>

        <div className="timeline">
          <div className="timeline-item left">
            <div className="timeline-content">
              <h3>2009 – Foundation</h3>
              <p>
                Established as <strong>R.K. Law College</strong>, with a vision
                to provide affordable and quality legal education, focusing on
              </p>
              <p>Bengaluru Law College stands today as a symbol of excellence in legal education, discipline, and community service, but its journey has been one of steady growth and visionary leadership. The Institution was originally established in 2009 as R.K. Law College, with the primary mission of providing affordable and quality legal education to aspiring students. At its inception, the college was guided by the ideals of nurturing legal professionals who would embody the principles of justice, ethics, and service to society.

Recognizing the need to expand its vision and impact, the Institution underwent a significant transformation in 2015. Under the stewardship of the Law Wings Educational Trust, the college was restructured and renamed Bengaluru Law College. This marked a turning point in its journey, ushering in a new era of academic innovation, infrastructural development, and broader community engagement. With this transition, the Institution strengthened its academic programs, introduced modern teaching methodologies, and created new avenues for student exposure through legal aid clinics, moot courts, seminars, and workshops.

Over the years, Bengaluru Law College has grown into a vibrant hub of learning, where classroom teaching is effectively blended with practical training. Students are encouraged not only to master the black-letter law but also to develop analytical, research, and advocacy skills essential to succeed in the legal profession. Regular internships with law firms, senior advocates, and NGOs further enhance their practical knowledge and career readiness.

The Institution flourishes under the inspiring leadership of:

President – Dr. Renuka Raju, who provides strategic vision and academic guidance.

Vice-President – Sri. K. Shailesh Raju, who plays a key role in strengthening governance and student development.

Managing Trustee & Treasurer – Prof. Prasanna V. Raju, who ensures that the Institution’s resources and values align with its mission of service and excellence.

Principal – Dr. Devika S. Ajila, who oversees day-to-day academic administration and fosters a nurturing environment for students and faculty alike.

The leadership’s collective vision has enabled Bengaluru Law College to uphold its tradition of academic excellence, ethical learning, and professional discipline, while steadily expanding opportunities for students to grow into well-rounded individuals.

In addition to academics, the college has always emphasized holistic development. Two flagship annual events are a testament to this philosophy:

“Tarang” – the Inter-Class Cultural Competition, which celebrates student creativity and cultural diversity through music, dance, debate, theatre, and literary events.

“Khel” – the Inter-Class Sports Competition, which instills values of teamwork, discipline, resilience, and sportsmanship among students through a variety of indoor and outdoor games.

These events, along with student participation in National Service Scheme (NSS), legal aid camps, and community service programs, reflect the college’s commitment to producing not just lawyers, but socially conscious citizens.

Today, Bengaluru Law College is recognized as a dynamic Institution where tradition meets innovation. It continues to produce graduates who are well-prepared to enter the legal profession as advocates, academicians, judges, corporate professionals, and policymakers. Guided by its motto of knowledge, discipline, and justice, the college remains steadfast in its mission to contribute to society by shaping responsible leaders in the field of law.</p>
            </div>
          </div>

          <div className="timeline-item right">
            <div className="timeline-content">
              <h3>2015 – Transformation</h3>
              <p>
                Under the stewardship of <strong>Law Wings Educational Trust</strong>, 
                the college was restructured and renamed{" "}
                <strong>Bengaluru Law College</strong>, marking a new era of
                growth, innovation, and community engagement.
              </p>
            <p>Bengaluru Law College has a proud legacy rooted in its commitment to quality legal education and social responsibility. The Institution began its journey in 2009 as R.K. Law College, with a vision to provide aspiring law students with a strong foundation in legal studies, professional skills, and ethical values.

In 2015, the college entered a new phase of growth and transformation when it came under the management of the Law Wings Educational Trust. With this transition, the Institution was renamed Bengaluru Law College, symbolizing a broader vision and renewed dedication to academic excellence, discipline, and community engagement.

Over the years, the college has developed into a vibrant hub for legal education, blending classroom learning with practical exposure through moot courts, internships, legal aid programs, and community outreach initiatives. Guided by experienced faculty and supported by modern facilities, Bengaluru Law College continues to nurture future advocates and leaders who uphold justice, ethics, and service to society.</p>
            </div>
          </div>

          <div className="timeline-item left">
            <div className="timeline-content">
              <h3>2016 – Beyond Classrooms</h3>
              <p>
                Introduced <strong>moot courts, internships, and legal aid
                clinics</strong> to blend academics with practical exposure.
              </p>
              <p>To make Bengaluru Law College a center of excellence in legal education that nurtures ethical, skilled, and socially responsible professionals. To provide quality education with values of justice and integrity. To empower students with knowledge, discipline, and practical skills. To foster innovation, research, and community service in the field of law.</p>
              <p>To establish Bengaluru Law College as a premier Institution of legal education, rooted in ethics, innovation, and academic excellence. The vision is to guide the college toward producing competent, disciplined, and socially responsible legal professionals who contribute to justice, governance, and nation-building. To provide a strong foundation of academic excellence supported by values of integrity and service. To ensure a student-centric environment that fosters discipline, knowledge, and holistic development. To promote access to quality legal education for all, nurturing inclusivity and equal opportunities. To strengthen Institutional growth through modern infrastructure, skilled faculty, and practical exposure. To encourage community service, social responsibility, and pro bono legal initiatives. To guide the Institution in building future leaders who uphold justice and the democratic framework of society.</p>
            
            </div>
          </div>

          <div className="timeline-item right">
            <div className="timeline-content">
              <h3>Today – A Premier Institution</h3>
              <p>
                Recognized for <strong>academic excellence, inclusiveness, and
                innovation</strong>, nurturing future advocates, leaders, and
                socially responsible citizens.
              </p>
            </div>
          </div>
        </div>

        <div className="closing">
          <p>
            Guided by visionary leadership, Bengaluru Law College continues to
            uphold its motto: <span>Knowledge, Discipline & Justice</span>.
          </p>
        </div>
      </div>
    </section> */}

      <section className="history-section">
        <div className="container">
          <h2 className="section-title">Our Journey</h2>
          <p className="intro">
            Bengaluru Law College has grown into a vibrant hub of excellence in
            legal education, discipline, and community service. Here’s a glimpse
            into our inspiring journey:
          </p>

          <div className="timeline">
            <div className="timeline-item left">
              <div className="timeline-content">
                {/* <h3>2009 – Foundation</h3> */}
                {/* <p>
                  Established as <strong>R.K. Law College</strong>, with a
                  vision to provide affordable and quality legal education,
                  focusing on
                </p> */}
                <p>Bengaluru Law College stands today as a symbol of excellence in legal education, discipline, and community service, but its journey has been one of steady growth and visionary leadership. <strong>The Institution was originally established in 2005</strong> as R.K. Law College, with the primary mission of providing affordable and quality legal education to aspiring students. At its inception, the college was guided by the ideals of nurturing legal professionals who would embody the principles of justice, ethics, and service to society.</p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="timeline-content">
                {/* <h3>2015 – Transformation</h3> */}
                {/* <p>
                  Under the stewardship of{" "}
                  <strong>Law Wings Educational Trust</strong>, the college was
                  restructured and renamed{" "}
                  <strong>Bengaluru Law College</strong>, marking a new era of
                  growth, innovation, and community engagement.
                </p> */}
                <p>Recognizing the need to expand its vision and impact, <strong>The Institution underwent a significant transformation in 2015.</strong> Under the stewardship of the Law Wings Educational Trust, the college was restructured and renamed Bengaluru Law College. This marked a turning point in its journey, ushering in a new era of academic innovation, infrastructural development, and broader community engagement. With this transition, the Institution strengthened its academic programs, introduced modern teaching methodologies, and created new avenues for student exposure through legal aid clinics, moot courts, seminars, and workshops.
                </p>
              </div>
            </div>

            <div className="timeline-item left">
              <div className="timeline-content">
                {/* <h3>Over the years</h3> */}
                {/* <p>
                  Introduced{" "}
                  <strong>
                    moot courts, internships, and legal aid clinics
                  </strong>{" "}
                  to blend academics with practical exposure.
                </p> */}
                <p>
                  <strong>Over the years, Bengaluru Law College has grown into a vibrant hub of learning,</strong> where classroom teaching is effectively blended with practical training. Students are encouraged not only to master the black-letter law but also to develop analytical, research, and advocacy skills essential to succeed in the legal profession. Regular internships with law firms, senior advocates, and NGOs further enhance their practical knowledge and career readiness.
                </p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="timeline-content">
                {/* <h3>The Institution flourishes under the inspiring leadership of:</h3> */}
                {/* <p>
                  Recognized for{" "}
                  <strong>
                    academic excellence, inclusiveness, and innovation
                  </strong>
                  The Institution flourishes under the inspiring leadership of:

President – Dr. Renuka Raju, who provides strategic vision and academic guidance.

Vice-President – Sri. K. Shailesh Raju, who plays a key role in strengthening governance and student development.

Managing Trustee & Treasurer – Prof. Prasanna V. Raju, who ensures that the Institution’s resources and values align with its mission of service and excellence.
                </p> */}
                <p>The Institution flourishes under the inspiring leadership of:<strong>President – Smt. Renuka Raju,</strong> who provides strategic vision and academic guidance. <br />

<strong>Vice-President – Sri. K. Shailesh Raju,</strong> who plays a key role in strengthening governance and student development.<br />

<strong>Managing Trustee & Treasurer – Prof Sri. Prasanna V. Raju,</strong> who ensures that the Institution’s resources and values align with its mission of service and excellence.
<br />
<strong>Principal – Dr. Devika S. Ajila,</strong> who oversees day-to-day academic administration and fosters a nurturing environment for students and faculty alike.

<br />

The leadership’s collective vision has enabled Bengaluru Law College to uphold its tradition of academic excellence, ethical learning, and professional discipline, while steadily expanding opportunities for students to grow into well-rounded individuals.
</p>
              </div>
            </div>
{/* ------------------------------------- */}
            <div className="timeline-item left">
              <div className="timeline-content">
                {/* <h3>In addition to academics</h3> */}
                {/* <p>
                  Introduced{" "}
                  <strong>
                    moot courts, internships, and legal aid clinics
                  </strong>{" "}
                  to blend academics with practical exposure.
                </p>
                <p>The Institution flourishes under the inspiring leadership of:

President – Dr. Renuka Raju, who provides strategic vision and academic guidance.

Vice-President – Sri. K. Shailesh Raju, who plays a key role in strengthening governance and student development.

Managing Trustee & Treasurer – Prof. Prasanna V. Raju, who ensures that the Institution’s resources and values align with its mission of service and excellence.</p> */}


<p>In addition to academics, the college has always emphasized holistic development. Two flagship annual events are a testament to this philosophy:

<strong>“Tarang” – the Inter-Class Cultural Competition,</strong> which celebrates student creativity and cultural diversity through music, dance, debate, theatre, and literary events.

<strong>“Khel” – the Inter-Class Sports Competition,</strong> which instills values of teamwork, discipline, resilience, and sportsmanship among students through a variety of indoor and outdoor games.

These events, along with student participation in National Service Scheme (NSS), legal aid camps, and community service programs, reflect the college’s commitment to producing not just lawyers, but socially conscious citizens.</p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="timeline-content">
                <h3>Today – A Premier Institution</h3>
                <p>Today, Bengaluru Law College is recognized as a dynamic Institution where tradition meets innovation. It continues to produce graduates who are well-prepared to enter the legal profession as advocates, academicians, judges, corporate professionals, and policymakers. Guided by its motto of knowledge, discipline, and justice, the college remains steadfast in its mission to contribute to society by shaping responsible leaders in the field of law.</p>
              </div>
            </div>

          </div>

          <div className="closing">
            <p>
              Guided by visionary leadership, Bengaluru Law College continues to
              uphold its motto: <span>Knowledge, Discipline & Justice</span>.
            </p>
          </div>
        </div>
      </section>

      {/* <Banner /> */}
      {/* <StepFlow /> */}
    </>
  );
};

export default HistorySection;
